import { render, staticRenderFns } from "./AllProductsRemissionComponent.vue?vue&type=template&id=5eb5f66d"
import script from "./AllProductsRemissionComponent.vue?vue&type=script&lang=js"
export * from "./AllProductsRemissionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports